import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyAMvMyNlJvNdcMg8pi3MhBpx0tAzW3KpCg",
    authDomain: "reatime-mta.firebaseapp.com",
    projectId: "reatime-mta",
    storageBucket: "reatime-mta.firebasestorage.app",
    messagingSenderId: "696660605811",
    appId: "1:696660605811:web:643d66c88e19104a5ca306",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
